import React from "react";
import { ObjectSelect } from "components/form";
import PropTypes from "prop-types";
import noop from "lodash/noop"; 

class ObjectSelectEditor extends React.Component {
    value = null;
    onSelect = (value) => {
        this.value = value;
    }
    componentWillUnmount() {
        this.props.onCommit(this.value);
    }
    render() {
        return (
            <div ref={ref => this.node = ref}>
                <ObjectSelect
                    placeholder={this.props.placeholder}
                    mode={this.props.mode}
                    onChange={this.onSelect}
                    onSelect={this.onSelect}
                    onSearch={this.props.onSearch || noop}
                    disabled={this.props.disabled}
                    showSearch={this.props.showSearch}
                    showArrow={true}
                    style={this.props.style}
                    loading={this.props.loading}
                    labelProp={this.props.labelProp}
                    dropdownMenuStyle={this.props.dropdownMenuStyle}
                    dataSource={this.props.options}
                    getOptionsOnFocus={this.props.getOptionsOnFocus}
                    popUpContainer={this.node}
                    open={true}
                />
            </div>
        );
    }
}

ObjectSelectEditor.propTypes = {
    placeholder: PropTypes.string,
    mode: PropTypes.string,
    defaultValue: PropTypes.object,
    onSelect: PropTypes.func,
    onSearch: PropTypes.func,
    disabled: PropTypes.bool,
    showSearch: PropTypes.bool,
    style: PropTypes.object,
    loading: PropTypes.bool,
    labelProp: PropTypes.string,
    dropdownMenuStyle: PropTypes.string,
    options: PropTypes.object,
    onCommit: PropTypes.func,
    getOptionsOnFocus: PropTypes.func
};

export default ObjectSelectEditor;